import React, {  useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import formConfig from './formConfig.json';

const useOutsideAlerter = (ref, callback) => {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

const DropdownMenu = ({ clientId = 'default', clientMockups }) => {
    // console.log('DropdownMenu render - clientId:', clientId);
    // console.log('DropdownMenu render - clientMockups:', clientMockups);
    
    const effectiveClientId = clientMockups || clientId;
    // console.log('DropdownMenu effectiveClientId:', effectiveClientId);
    
    const hideMenu = formConfig[effectiveClientId]?.hideMenu || formConfig.default.hideMenu;
    // console.log('DropdownMenu hideMenu value:', hideMenu);

    const wrapperRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    useOutsideAlerter(wrapperRef, () => setIsOpen(false));

    if (hideMenu) {
        return null; // Don't render anything if hideMenu is true
    }

    return (
        <div className="relative inline-block w-full text-right" ref={wrapperRef}>
            <div className="justify-end">
                <button
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white hover:bg-gray-100 focus:outline-none"
                    id="options-menu"
                    aria-haspopup="true"
                    aria-expanded="true"
                >
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                    </svg>
                </button>
            </div>

            {isOpen && (
                <div className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                    <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                        <Link to="/?mockupPage=logoToMockup" className="block px-4 py-2 text-sm text-center text-gray-700 hover:bg-gray-100 no-underline" role="menuitem">
                        Logo To Mockup
                        </Link>
                        <Link to="/multiplacement" className="block px-4 py-2 text-sm text-center text-gray-700 hover:bg-gray-100 no-underline" role="menuitem">
                        Logo + Text To Mockup
                        </Link>
                        <Link to="/text" className="block px-4 py-2 text-sm text-center text-gray-700 hover:bg-gray-100 no-underline" role="menuitem">
                        Just Text
                        </Link>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DropdownMenu;
